<template>
  <section>
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <!-- HEADER -->
      <template #header>
        <div class="row custom-header">
          <div class="col">
            <h4 class="modal-title">
              {{ title }}
            </h4>
            <div class="custom-subtitle">
              <span>for {{ subtitle }}</span>
              <div v-if="!isAdd" class="ms-3">
                <div class="input-group">
                  <span class="me-2">move to:</span>
                  <select v-model="moveToAdasCategory" class="form-control custom-select">
                    <option v-for="item of adasMakeMatrixCategories" :key="item.adasChecklistMatrix" :value="item.adasChecklistMatrix">
                      {{ item.matrixItem }}
                    </option>
                  </select>
                  <button class="btn btn-primary btn-sm" @click="moveToCategory">Move</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <!-- BODY -->
      <template #body>
        <div class="custom-body">
          <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
          <div class="custom-vehicle-info">{{ vehicleInfo }}</div>
          <div v-if="currentTab === 'Vehicle'" class="row">
            <div class="col mt-3">
              <!-- Explanation -->
              <p>{{ notice }}</p>
              <div class="row">
                <div class="col-1" @click="closeModelVariability()"></div>
                <div class="col" @click="closeModelVariability()">
                  <!-- ADD: show ability to select multiple vehicle makes -->
                  <label v-if="isAdd" for="makeLookup">Make(s):<span class="text-danger">*</span></label>
                  <Multiselect
                    v-if="isAdd"
                    ref="searchMakes"
                    v-model="makes"
                    class="form-control custom-multiselect"
                    placeholder="choose make(s)"
                    :open-direction="'bottom'"
                    :options="lookups['VehicleMake']"
                    mode="tags"
                    label="name"
                    value-prop="value"
                    @select="isSave = true"
                  />
                  <!-- EDIT: otherwise, just a single vehicle make choice -->
                  <z-select
                    v-else
                    v-model="make"
                    label="Make"
                    name="make"
                    :options="lookups['VehicleMake']"
                    :required="true"
                    @change="isSave = true"
                  />
                </div>
                <div class="col-3">
                  <div class="custom-model-exclusions-info">
                    <a
                      v-popover
                      tab-index="0"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus hover"
                      data-bs-html="true"
                      data-bs-sanitize="false"
                      title="Information"
                      :data-bs-content="`Use the exclusions for model exclusions. Keep the model entered here simple (one to two words). Remember, it's used as a wildcard.`"
                      class="btn btn-link"
                      role="button"
                    >
                      <i class="fas fa-info-circle"></i>
                    </a>
                  </div>
                  <!-- Model Variability -->
                  <div class="input-group custom-model-variability">
                    <span class="input-group-text">Model<span class="custom-required">*</span></span>
                    <input v-model="model" type="text" class="form-control" @keyup="isSave = true" />
                    <button class="btn custom-btn custom-btn-focus" type="button" tabindex="-1" @click="showAddModelVariability()">
                      <i v-show="showingAddModelVariability" class="fas fa-chevron-up"></i>
                      <i v-show="!showingAddModelVariability" class="fas fa-plus text-success"></i>
                    </button>
                    <button class="btn custom-btn custom-btn-right-radius custom-btn-focus" tabindex="-1" @click="showModelVariability()">
                      <i v-show="showingModelVariability" class="fas fa-chevron-up"></i>
                      <i v-show="!showingModelVariability" class="fas fa-chevron-down"></i>
                      <span class="custom-model-count">{{ models.length }}</span>
                    </button>
                    <div v-show="isShowAddModelVariability" class="custom-variability">
                      <div class="input-group">
                        <input
                          v-model="newModelVariability"
                          type="text"
                          class="form-control"
                          placehoder="model alternative"
                          @keyup.enter="addModelVariability()"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn custom-btn custom-btn-right-radius custom-btn-focus"
                            tabindex="-1"
                            :disabled="!isModelThere"
                            @click="addModelVariability()"
                          >
                            <i class="fas fa-check" :class="{ 'text-success': isModelThere }"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-show="isShowModelVariability" class="custom-variability custom-variability-list">
                      <ul :id="modelVariabilityCount" class="custom-model-variability-list">
                        <li v-for="item in models" :key="item.id">
                          <span>{{ item.name }}</span>
                          <a href="#" class="custom-remove" @click="removeModelVariability(item.id)">
                            <i class="fas fa-times text-danger"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <span class="custom-model-exclusions">exclusions</span>
                  </div>
                </div>
                <!-- Years -->
                <div class="col-1" @click="closeModelVariability()">
                  <z-select v-model="yearStart" label="Year Start" :options="years" :required="true" @change="isSave = true" />
                </div>
                <div class="col-1" @click="closeModelVariability()">
                  <z-select v-model="yearEnd" label="Year End" :options="years" :required="true" @change="isSave = true" />
                </div>
                <!-- Type -->
                <div class="col-2" @click="closeModelVariability()">
                  <z-select v-model="matrixSource" label="Type" :options="infoTypes" :disabled="true" @change="isSave = true" />
                </div>
                <div class="col-1 custom-value-wrapper" @click="closeModelVariability()">
                  <input v-model="isInactive" class="custom-checkbox ml-2" type="checkbox" @change="isSave = true" />
                  <span class="ml-2">Inactive?</span>
                </div>
                <div class="col-1" @click="closeModelVariability()"></div>
              </div>
              <!-- NON-ALLDATA: Description -->
              <div v-if="matrixSource === 2 || matrixSource === 3" class="row">
                <div class="col-2"></div>
                <div class="col-4">
                  <z-input v-model="system" label="Description" name="description" :maxlength="1000" :required="true" @keyup="isSave = true" />
                </div>
                <div class="col-6"></div>
              </div>
              <!-- NON-ALLDATA: URL -->
              <div v-if="matrixSource === 2 || matrixSource === 3" class="row" @click="closeModelVariability()">
                <div class="col-2"></div>
                <div class="col-8">
                  <z-input v-model="url" label="Url" name="url" :required="true" @keyup="isSave = true" />
                </div>
                <div class="col-2"></div>
              </div>
              <!-- SYSTEM / LOCATION -->
              <div v-if="matrixSource === 1" class="row" @click="closeModelVariability()">
                <div class="col-2"></div>

                <div class="col-4">
                  <z-select v-model="systemType" name="system" label="System" :options="adassystems" :required="true" @change="isSave = true" />
                </div>
                <div class="col-4">
                  <z-select
                    v-model="locationType"
                    name="location"
                    label="Location"
                    :options="adaslocations"
                    :required="true"
                    @change="isSave = true"
                  />
                </div>
                <div class="col-3"></div>
              </div>
              <!-- Estimatic Keyword Lookups -->
              <div v-if="matrixSource === 1" class="row" @click="closeModelVariability()">
                <div class="col-4">
                  <!-- Location Keywords to lookup -->
                  <div class="row">
                    <div class="col-12">
                      <span>Location (Header) Keywords:</span>
                      <div class="input-group mb-3 mt-2">
                        <input
                          v-show="isCreateCccLocationKeyword"
                          ref="refCreateCccLocationKeyword"
                          v-model="newCccLocationKeyword"
                          type="text"
                          class="form-control"
                          placeholder="new Location Keyword"
                          aria-label="new Location Keyword"
                          @keyup="addingCccLocationKeyword"
                        />
                        <select v-show="!isCreateCccLocationKeyword" v-model="newCccLocationKeyword" class="form-control custom-select">
                          <option v-for="item of cccKeywordsLocation" :key="item.id">
                            {{ cleanName(item.name) }}
                          </option>
                        </select>
                        <button
                          class="btn custom-focus"
                          :class="{ 'btn-warning': isCreateCccLocationKeyword, 'btn-success': !isCreateCccLocationKeyword }"
                          type="button"
                          tabindex="-1"
                          @click="createCccLocationKeyword"
                        >
                          <i class="far fa-edit"></i>
                        </button>
                        <button class="btn btn-primary custom-focus" type="button" tabindex="-1" @click="addCccLocationKeyword">Add</button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- List of Location Keywords that'll be examined -->
                    <div class="col-12 custom-list-wrapper">
                      <ul :id="cnt" class="custom-list">
                        <li v-for="(item, idx) in cccLocationKeywords" :key="idx">
                          <div class="row">
                            <div class="col-10">
                              <span>{{ cleanName(item) }}</span>
                            </div>
                            <div class="col-2 text-right">
                              <a href="#" class="custom-remove" tabindex="-1" @click="removeCccLocationKeyword(item)">
                                <i class="fas fa-times text-danger"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <!-- CCC Labor Keywords to lookup -->
                  <div class="row">
                    <div class="col-12">
                      <span>Labor Keywords:</span>
                      <div class="input-group mb-3 mt-2">
                        <input
                          v-show="isCreateCccLineKeyword"
                          ref="refCreateCccLineKeyword"
                          v-model="newCccLineKeyword"
                          type="text"
                          class="form-control"
                          placeholder="new Line Keyword"
                          aria-label="new Line Keyword"
                          @keyup="addingCccLineKeyword"
                        />
                        <select v-show="!isCreateCccLineKeyword" v-model="newCccLineKeyword" class="form-control custom-select">
                          <option v-for="item of cccKeywordsLine" :key="item.id">
                            {{ cleanName(item.name) }}
                          </option>
                        </select>
                        <button
                          class="btn custom-focus"
                          :class="{ 'btn-warning': isCreateCccLineKeyword, 'btn-success': !isCreateCccLineKeyword }"
                          type="button"
                          tabindex="-1"
                          @click="createCccLineKeyword"
                        >
                          <i class="far fa-edit"></i>
                        </button>
                        <button class="btn btn-primary custom-focus" type="button" tabindex="-1" @click="addCccLineKeyword">Add</button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- List of CCC Labor Keywords that'll be examined -->
                    <div class="col-12 custom-list-wrapper">
                      <ul class="custom-list">
                        <li v-for="(item, idx) in cccLineKeywords" :key="idx">
                          <div class="row">
                            <div class="col-10">
                              <span>{{ cleanName(item) }}</span>
                            </div>
                            <div class="col-2 text-right">
                              <a href="#" class="custom-remove" tabindex="-1" @click="removeCccLineKeyword(item)">
                                <i class="fas fa-times text-danger"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <!-- Parts Keywords to lookup -->
                  <div class="row">
                    <div class="col-12">
                      <span>Parts Keywords:</span>
                      <div class="input-group mb-3 mt-2">
                        <input
                          v-show="isCreateCccSubletKeyword"
                          ref="refCreateCccSubletKeyword"
                          v-model="newCccSubletKeyword"
                          type="text"
                          class="form-control"
                          placeholder="new Sublet Keyword"
                          aria-label="new Sublet Keyword"
                          @keyup="addingCccSubletKeyword"
                        />
                        <select v-show="!isCreateCccSubletKeyword" v-model="newCccSubletKeyword" class="form-control custom-select">
                          <option v-for="item of cccKeywordsSublet" :key="item.id">
                            {{ cleanName(item.name) }}
                          </option>
                        </select>
                        <button
                          class="btn custom-focus"
                          :class="{ 'btn-warning': isCreateCccSubletKeyword, 'btn-success': !isCreateCccSubletKeyword }"
                          type="button"
                          tabindex="-1"
                          @click="createCccSubletKeyword"
                        >
                          <i class="far fa-edit"></i>
                        </button>
                        <button class="btn btn-primary custom-focus" type="button" tabindex="-1" @click="addCccSubletKeyword">Add</button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- List of CCC Parts Keywords that'll be examined -->
                    <div class="col-12 custom-list-wrapper">
                      <ul class="custom-list">
                        <li v-for="(item, idx) in cccSubletKeywords" :key="idx">
                          <div class="row">
                            <div class="col-10">
                              <span>{{ cleanName(item) }}</span>
                            </div>
                            <div class="col-2 text-right">
                              <a href="#" class="custom-remove" tabindex="-1" @click="removeCccSubletKeyword(item)">
                                <i class="fas fa-times text-danger"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!--Additional Operations-->
                  <div class="row">
                    <div class="col-12">
                      <div class="mt-3" @click="closeModelVariability()">
                        <input v-model="isAddlOperationRequired" class="" type="checkbox" @change="isSave = true" />
                        <span class="ml-2">Add'l Operation Required</span>
                      </div>
                      <div v-if="isAddlOperationRequired" class="input-group mb-3 mt-2">
                        <input
                          v-show="isCreateAddlOperation"  ref="refCreateAddlOperation" v-model="newAddlOperation" type="text"
                          class="form-control" placeholder="new Additional Operation"
                          aria-label="new Additional Operation" @keyup="addingAddlOperation" />
                        <select v-show="!isCreateAddlOperation" v-model="newAddlOperation" class="form-control custom-select">
                          <option v-for="item of allAddlOperations" :key="item.id">
                            {{ cleanName(item.name) }}
                          </option>
                        </select>
                        <div class="input-group-append">
                          <button
                            class="btn custom-focus"
                            :class="{ 'btn-warning': isCreateAddlOperation, 'btn-success': !isCreateAddlOperation }"
                            type="button" tabindex="-1" @click="createAddlOperation">
                            <i class="far fa-edit"></i>
                          </button>
                        </div>
                        <div class="input-group-append">
                          <button
                            class="btn btn-primary custom-focus" type="button" tabindex="-1"
                            @click="addAddlOperation">Add</button>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isAddlOperationRequired" lass="row">
                    <div class="col-12 custom-list-wrapper">
                      <ul class="custom-list">
                        <li v-for="(item, idx) in selectedAddlOperations" :key="idx">
                          <div class="row">
                            <div class="col-10">
                              <input class="" type="checkbox" :checked="item.isActive" @change="onAddlOperationStatusChanged($event, item, idx)" />
                              <span class="ml-2">{{ cleanName(item.addlOperation) }}</span>
                            </div>
                            <div class="col-2 text-right">
                              <a href="#" class="custom-remove" tabindex="-1" @click="removeAddlOperation(item)">
                                <i class="fas fa-times text-danger"></i>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- CALIBRATION / TRIGGER -->
              <div v-if="matrixSource === 1" class="row mt-2" @click="closeModelVariability()">
                <div class="col-2"></div>
                <div class="col-4">
                  <z-select
                    v-model="calibrationType"
                    label="Services Required"
                    name="calibrationType"
                    :options="calibrationTypes"
                    :required="true"
                    :disabled ="categoryOrChecked"
                    @change="isSave = true"
                  />
                </div>
                <div class="col-2">
                  <div class="category-or-wrapper">
                    <input id="categoryOR" type="checkbox" v-model="categoryOrChecked"/>
                    <label for="categoryOR" >OR Checkbox OEM allows component to be calibrated multiple ways</label>
                  </div>
                </div>
                <div class="col">
                  <button class="btn btn-primary btn-sm custom-trigger" @click="showTrigger">
                    <span class="me-2">Trigger Notice</span><i v-if="isTriggerThere" class="fa fa-check"></i>
                  </button>
                </div>
              </div>
              <div v-show="categoryOrChecked" class="row mt-2">
                  <div class="col-2"></div>  
                  <div class="col-4">
                      <div v-for="(item, idx) in addedSubCategories" :key="item.id">
                        <div class="row">
                          <div  class="col-11">
                            <z-select
                              class="calibrationSubTypeSelect"
                              name="calibrationSubType"
                              validate="required"
                              :options="calibrationSubTypeOptions"
                              v-model="item.value"
                            />
                          </div>
                          <div class="col-1 subcategoryRemove">
                            <button
                              type="button"
                              class="border rounded "
                              @click="removeSubcategoryOptionAt(idx)"
                              aria-label="Remove dropdown">
                                <i class="fas fa-times text-danger"></i>
                            </button>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-2">
                    <button class="btn btn-success btn-sm" @click="addSubCategoryOption()">
                        <span>Add Option</span><i class="fa fa-plus ml-2"></i>
                    </button>
                  </div>  
                </div>
            </div>
          </div>
          <div v-if="currentTab === 'ALLDATA' && !isAdd" class="row">
            <div class="col mt-3">
              <div class="row">
                <div class="col custom-ids">
                  <p>
                    The following are ALLDATA Keywords used to look up the appropriate ALLDATA url links associated with this year/make/model in real
                    time. Use the Links tab to manage internally saved ALLDATA links.
                  </p>
                  <p>
                    NOTE: clicking the 'Pull from ALLDATA' may pull by Make Only (if Model cannot be found/matched). This will create links for other
                    Models as well.
                  </p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <!-- ALLDATA: System, Location, Static Calibration, Dynamic Calibration -->
                  <div v-if="matrixSource === 1" class="row">
                    <div class="col-3">
                      <!-- System -->
                      <div class="row">
                        <div class="col-12">
                          <span>System Keyword Lookups:</span>
                          <div class="input-group mb-3">
                            <input
                              v-model="newSystem"
                              type="text"
                              class="form-control"
                              placeholder="new system"
                              aria-label="new system"
                              @keyup="addingSystem"
                            />
                            <button class="btn btn-primary" type="button" tabindex="-1" @click="addSystem">Add</button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 custom-list-wrapper">
                          <ul class="custom-list">
                            <li v-for="(item, idx) in systems" :key="idx">
                              <div class="row">
                                <div class="col-10">
                                  <span>{{ item }}</span>
                                </div>
                                <div class="col-2 text-right">
                                  <a href="#" class="custom-remove" tabindex="-1" @click="removeSystem(item)">
                                    <i class="fas fa-times text-danger"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-3">
                      <!-- Location -->
                      <div class="row">
                        <div class="col-12">
                          <span>Location Keyword Lookups:</span>
                          <div class="input-group mb-3">
                            <input
                              v-model="newLocation"
                              type="text"
                              class="form-control"
                              placeholder="new location"
                              aria-label="new location"
                              @keyup="addingLocation"
                            />
                            <button class="btn btn-primary" type="button" tabindex="-1" @click="addLocation">Add</button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 custom-list-wrapper">
                          <ul class="custom-list">
                            <li v-for="(item, idx) in locations" :key="idx">
                              <div class="row">
                                <div class="col-10">
                                  <span>{{ item }}</span>
                                </div>
                                <div class="col-2 text-right">
                                  <a href="#" class="custom-remove" tabindex="-1" @click="removeLocation(item)">
                                    <i class="fas fa-times text-danger"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-3">
                      <!-- Static Calibration -->
                      <div class="row">
                        <div class="col-12">
                          <span>Static Calibration Keyword Lookups:</span>
                          <div class="input-group mb-3">
                            <input
                              v-model="newStatic"
                              type="text"
                              class="form-control"
                              placeholder="new static"
                              aria-label="new static"
                              @keyup="addingStatic"
                            />
                            <button class="btn btn-primary" type="button" tabindex="-1" @click="addStatic">Add</button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 custom-list-wrapper">
                          <ul class="custom-list">
                            <li v-for="(item, idx) in staticCalibrate" :key="idx">
                              <div class="row">
                                <div class="col-10">
                                  <span>{{ item }}</span>
                                </div>
                                <div class="col-2 text-right">
                                  <a href="#" class="custom-remove" tabindex="-1" @click="removeStatic(item)">
                                    <i class="fas fa-times text-danger"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-3">
                      <!-- Dyanmic Calibration -->
                      <div class="row">
                        <div class="col-12">
                          <span>Dynamic Calibration Keyword Lookups:</span>
                          <div class="input-group mb-3">
                            <input
                              v-model="newDynamic"
                              type="text"
                              class="form-control"
                              placeholder="new dynamic"
                              aria-label="new dynamic"
                              @keyup="addingDynamic"
                            />
                            <button class="btn btn-primary" type="button" tabindex="-1" @click="addDynamic">Add</button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 custom-list-wrapper">
                          <ul class="custom-list">
                            <li v-for="(item, idx) in dynamicCalibrate" :key="idx">
                              <div class="row">
                                <div class="col-10">
                                  <span>{{ item }}</span>
                                </div>
                                <div class="col-2 text-right">
                                  <a href="#" class="custom-remove" tabindex="-1" @click="removeDynamic(item)">
                                    <i class="fas fa-times text-danger"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'Links' && !isAdd" class="row">
            <div class="col">
              <div class="row mt-2">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">Type</span>
                        <select v-model="viewLookup" class="form-control" @change="changedView">
                          <option v-for="item of lookupTypes" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">Year</span>
                        <select v-model="viewYear" class="form-control" @change="changedView">
                          <option v-for="item of viewYears" :key="item.id" :value="item.value">{{ item.name }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">Model</span>
                        <button class="btn btn-success" type="button" title="add new model" :disabled="isAddModel" @click="addModel">
                          <span>
                            <i class="fas fa-plus"></i>
                          </span>
                        </button>
                        <select v-if="!isAddModel" v-model="viewModel" class="form-control" @change="changedView">
                          <option v-for="item of viewModels" :key="item.id" :value="item.value">{{ item.name }}</option>
                        </select>
                        <input v-else ref="refNewModel" v-model="newModel" class="form-control" @keypress.enter.prevent="checkForEnter" />
                        <button
                          v-if="isAddModel"
                          class="btn btn-success"
                          type="button"
                          title="add new model"
                          :disabled="isSavingNewModel"
                          @click="addModel"
                        >
                          <span>
                            <i class="fas fa-save"></i>
                          </span>
                        </button>
                        <button class="btn btn-danger" type="button" title="clear model selection" @click="clearModel">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-2 mt-2">
                  <div class="row mb-2">
                    <div class="col">
                      <div class="row">
                        <div class="col">
                          <span
                            >Links (
                            <FontAwesomeIcon v-if="isRemoving" icon="fa-solid fa-spinner" spin />
                            {{ links.length }}
                            ):</span
                          >
                        </div>
                        <div class="col-1">
                          <input
                            v-model="checkAll"
                            type="checkbox"
                            :true-value="true"
                            :false-value="false"
                            class="custom-all-checkbox"
                            title="check all links"
                            @click="checkingAll"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="custom-link-ids-wrapper">
                        <ul class="custom-link-ids">
                          <li
                            v-for="(item, idx) of links"
                            :key="idx"
                            class="custom-link-id"
                            :class="{ 'custom-link-id-selected ': item.isSelected }"
                            @click="viewAdasLink(item.adaslinks)"
                          >
                            <div>
                              <span>{{ item.year }} {{ item.model }}</span>
                            </div>
                            <div>
                              <span class="custom-year-model">#{{ item.adaslinks }} - {{ processType(item.lookupType) }}</span>
                              <input
                                v-model="item.isChecked"
                                type="checkbox"
                                class="custom-link-check"
                                true-value="true"
                                false-value="false"
                                title="check to remove"
                                @click="checkAdasLink(item.adaslinks)"
                              />
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div class="row custom-link-actions">
                        <div class="col">
                          <div class="input-group">
                            <input v-model="modelExcept" type="text" class="form-control" placeholder="except models" :disabled="isRemoving" />
                            <button class="btn btn-primary btn-sm" :disabled="isRemoving" @click="uncheckExceptModels">
                              <i class="fas fa-not-equal"></i>
                            </button>
                            <button
                              class="btn btn-secondary btn-sm"
                              :class="{ 'btn-danger': isCheckedRemoveLinks }"
                              :disabled="isRemoving"
                              @click="removeCheckedLinks"
                            >
                              remove
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row custom-link-actions">
                        <div class="col">
                          <div class="input-group">
                            <span class="me-2">sort by:</span>
                            <select v-model="sortBy" class="form-control" @change="changedSort">
                              <option v-for="item of sorts" :key="item.id" :value="item.value">{{ item.name }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-3">
                          <button v-if="isCheckedRemoveLinks" class="btn btn-secondary btn-sm" @click="editSelectedLinks">edit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col mt-2">
                  <div class="row">
                    <div class="col">
                      <p>
                        When you select one of the Ids (from the left), the following are the associated ALLDATA links. To add a new link, enter in
                        the Link's title and url, then press Add.
                      </p>
                    </div>
                    <div class="col-1">
                      <a
                        v-popover
                        tab-index="0"
                        data-bs-toggle="popover"
                        data-bs-trigger="focus hover"
                        data-bs-html="true"
                        data-bs-sanitize="false"
                        title="Information"
                        :data-bs-content="`You can create a hierarchical structure using the >> characters in your title. Also, you can insert links by reusing existing
                        structure naming.`"
                        class="btn btn-link"
                        role="button"
                      >
                        <i class="fas fa-info-circle"></i>
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <!-- Link Add -->
                    <div class="col-10">
                      <div class="input-group mb-3">
                        <Multiselect
                          v-if="isAdd"
                          ref="types"
                          v-model="types"
                          class="form-control custom-multiselect"
                          placeholder="choose type(s)"
                          :open-direction="'bottom'"
                          :options="lookupTypes"
                          mode="tags"
                          label="name"
                          value-prop="value"
                          @select="selectedType"
                        />
                        <input
                          v-model="newLink.title"
                          type="text"
                          class="form-control custom-link-input"
                          placeholder="new link name"
                          aria-label="new link name"
                        />
                        <input
                          v-model="newLink.url"
                          type="text"
                          class="form-control custom-link-input"
                          placeholder="new link url"
                          aria-label="new link url"
                          @keyup.enter.prevent="addLink"
                        />
                        <button class="btn btn-primary" type="button" tabindex="-1" :disabled="adaslinkSelected === 0" @click="addLink">Add</button>
                      </div>
                    </div>
                    <div class="col-2 custom-preview">
                      <button v-if="urlLinks.length > 0" class="btn btn-primary btn-sm" @click="previewLink">
                        <i class="fas fa-eye"></i>
                        <span class="ms-2">Preview</span>
                      </button>
                      <span class="custom-links-right">{{ urlLinks.length }}</span>
                      <input
                        v-if="urlLinks.length > 0"
                        v-model="checkAllLinks"
                        type="checkbox"
                        :true-value="true"
                        :false-value="false"
                        class="custom-all-urls-checkbox"
                        title="check all url links"
                        @click="checkingAllLinks"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <!-- Link List -->
                    <div class="col custom-list-links-wrapper">
                      <span v-if="loading">loading...</span>
                      <ul v-if="urlLinks.length > 0 && !loading" class="custom-list">
                        <li v-for="(item, idx) in urlLinks" :key="idx" :class="{ 'custom-green-background': item.isNew }">
                          <div class="row custom-link">
                            <div class="col-10">
                              <span class="custom-link-title">{{ item.title }}</span>
                              <span class="ms-3 custom-link-url">{{ trimUrl(item.url) }}</span>
                            </div>
                            <div class="col-2 text-right">
                              <input
                                v-model="item.isChecked"
                                type="checkbox"
                                class="custom-link-check"
                                true-value="true"
                                false-value="false"
                                title="check to remove"
                                @click="checkAdasLinkUrl(item.id)"
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                      <span v-if="urlLinks.length === 0 && !loading">none</span>
                    </div>
                  </div>
                  <div v-if="urlLinks.length > 0" class="row custom-link-actions">
                    <div class="col mt-1">
                      <button
                        class="btn btn-secondary btn-sm"
                        :class="{ 'btn-danger': isCheckedRemoveUrlLinks }"
                        :disabled="isRemovingUrls"
                        @click="removeCheckedUrlLinks"
                      >
                        remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'Exceptions' && !isAdd" class="row">
            <div class="col">
              <make-matrix-exceptions :adas-checklist-matrix-vehicle="adasChecklistMatrixVehicle" />
            </div>
          </div>
        </div>
      </template>
      <!-- FOOTER -->
      <template #footer>
        <div class="row custom-footer">
          <div class="col-2">
            <span>{{ id }}</span>
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
            <div v-if="isPulling">{{ pullProgress }}</div>
          </div>
          <div class="col-4 custom-right-align">
            <button v-if="id !== null && currentTab === 'ALLDATA'" type="button" class="btn btn-light mr-4" :disabled="isPulling" @click="pull()">
              Pull from ALLDATA
              <FontAwesomeIcon v-if="isPulling" icon="fa-solid fa-spinner" spin />
            </button>
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isShowActions" type="button" class="btn btn-primary ms-1" :class="{ 'btn-danger': isSave }" @click="save(true)">
              Save
            </button>
            <button v-show="isShowActions" type="button" class="btn btn-primary ms-1" :class="{ 'btn-danger': isSave }" @click="save(false)">
              Save & Close
            </button>
          </div>
        </div>
      </template>
    </z-dialog>
    <dialog-trigger v-model="actionTrigger" @closing="closeModal" @changed="isSave = true" />
    <dialog-preview-link v-model="actionView" @closing="closeModal" @saved="closeModal" />
    <confirm
      v-model="actionMove"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      @closing="closeModal"
      @proceed="performMove"
    />
    <confirm
      v-model="actionDelete"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      @closing="closeModal"
      @proceed="performDelete"
    />
    <dialog-adaslinks-edit v-model="actionEditLinks" @closing="closeModal" @save="performLinksUpdate" />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import globals from '@/plugins/globals'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import Confirm from '@/components/utilities/elements/ConfirmDialog.vue'
import Multiselect from '@vueform/multiselect'
import DialogTrigger from './dialog-trigger.vue'
import DialogPreviewLink from './dialog-preview-link.vue'
import DialogAdaslinksEdit from './dialog-adaslinks-edit.vue'
import MakeMatrixExceptions from './make-matrix-exceptions.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import _ from 'lodash'
export default {
  name: 'DialogMakeMatrix',
  components: {
    ZDialog,
    ZMessage,
    ZInput,
    ZSelect,
    ZTabs,
    Confirm,
    Multiselect,
    DialogTrigger,
    DialogPreviewLink,
    DialogAdaslinksEdit,
    MakeMatrixExceptions,
    FontAwesomeIcon
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-lgr',
      message: '',
      isSave: false,
      newLocation: null,
      newSystem: null,
      newStatic: null,
      newDynamic: null,
      makes: [],
      actionTrigger: null,
      actionView: null,
      isCreateCccLineKeyword: false,
      newCccLineKeyword: null,
      isCreateCccLocationKeyword: false,
      newCccLocationKeyword: null,
      isCreateCccSubletKeyword: false,
      newCccSubletKeyword: null,
      newSubletKeyword: null,
      currentTab: 'Vehicle',
      newLink: {
        id: 0,
        title: null,
        url: null
      },
      adaslinkSelected: 0,
      checkedLinks: [],
      checkAll: false,
      checkedLinkUrls: [],
      checkAllLinks: false,
      actionDelete: null,
      actionMove: null,
      actionEditLinks: null,
      confirmTitle: 'Remove these ADAS Link(s)?',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove these ADAS Link(s)?',
      loading: false,
      viewLookup: 1,
      viewYear: null,
      viewModel: null,
      isAddModel: false,
      newModel: null,
      newModels: [],
      modelExcept: null,
      isSavingNewModel: false,
      isRemoving: false,
      isRemovingUrls: false,
      isPulling: false,
      pullProgress: null,
      // 0 = System, 1 = Location, 2 = Static, 3 = Dynamic, 99 = ALL
      lookupTypes: [
        {
          id: 1,
          name: 'System',
          value: 1
        },
        {
          id: 2,
          name: 'Location',
          value: 2
        },
        {
          id: 3,
          name: 'Static',
          value: 3
        },
        {
          id: 4,
          name: 'Dynamic',
          value: 4
        }
      ],
      types: [],
      isImporting: false,
      sorts: [
        {
          id: 0,
          name: 'year',
          value: 'year'
        },
        {
          id: 1,
          name: 'model',
          value: 'model'
        }
      ],
      sortBy: 'year',
      moveToAdasCategory: null,
      isShowActions: true,
      newModelVariability: null,
      isShowModelVariability: false,
      showingModelVariability: false,
      isShowAddModelVariability: false,
      showingAddModelVariability: false,
      modelVariabilityCount: 0,
      cnt: 0,
      addedSubCategories: null,
      loadedSubCategories: false,
      isCreateAddlOperation: false,
      newAddlOperation: null
    }
  },
  async mounted() {
    this.reset()
  },
  emits: ['input', 'closing', 'saved'],
  computed: {
    ...mapState(adasmatrixStore, ['lookups', 'adasmakematrix', 'adasLink', 'adasLinks', 'adasMakeMatrixCategories']),
    isVisible() {
      return this.modelValue !== null
    },
    id() {
      let _data = null
      if (this.adasmakematrix !== undefined && this.adasmakematrix !== null) {
        if (this.adasmakematrix.adasChecklistMatrixVehicle !== null) {
          _data = `# ${this.adasmakematrix.adasChecklistMatrixVehicle}`
        }
      }
      return _data
    },
    title() {
      let _title = 'Editing Make Matrix'
      if (this.isAdd) {
        _title = 'Add Make Matrix'
      }
      return _title
    },
    subtitle() {
      let _data = null
      if (this.modelValue) {
        _data = this.modelValue.subtitle
      }
      return _data
    },
    isAdd() {
      let _is = false
      if (this.modelValue) {
        if (this.modelValue.type === 'ADD') {
          _is = true
        }
      }
      return _is
    },
    tabs() {
      let _tabs = ['Vehicle']
      if (!this.isAdd) {
        _tabs.push('ALLDATA')
        _tabs.push('Links')
        _tabs.push('Exceptions')
      }
      return _tabs
    },
    notice() {
      let _notice =
        'Select the vehicle make, model, range of years. Then, supply the System/Location along with associative CCC keyword lookups. Finally, provide the required Calibration (optional) along with a Trigger Notice.'
      return _notice
    },
    viewYears() {
      let _data = []
      let cnt = 0
      for (let idx = this.yearStart; idx <= this.yearEnd; idx++) {
        _data.push({
          id: cnt,
          name: idx,
          value: idx
        })
        cnt++
      }
      return _data
    },
    viewModels() {
      let _data = []
      let cnt = 0
      if (this.links) {
        this.links.forEach((element) => {
          let found = _data.find((x) => x.name === element.model)
          if (!found) {
            if (element.model) {
              _data.push({
                id: cnt,
                name: element.model,
                value: element.model
              })
              cnt++
            }
          }
        })
        this.newModels.forEach((element) => {
          if (element) {
            if (element.trim() !== '') {
              _data.push({
                id: cnt,
                name: element,
                value: element
              })
            }
          }
          cnt++
        })
      }
      return _data
    },
    years() {
      let _data = []
      let now = new Date()
      let nowYear = now.getFullYear()
      let numValues = 6
      let cnt = 0
      for (let idx = numValues; idx > 0; idx--) {
        _data.push({
          id: cnt,
          name: nowYear + idx,
          value: nowYear + idx
        })
        cnt++
      }
      numValues = nowYear - 1980
      for (let idx = numValues; idx > 0; idx--) {
        _data.push({
          id: cnt,
          name: 1980 + idx,
          value: 1980 + idx
        })
      }
      return _data
    },
    calibrationTypes() {
      let _data = []
      if (this.lookups['CalibrationType']) {
        let types = JSON.parse(JSON.stringify(this.lookups['CalibrationType']))
        _data = globals.sortArray(types, 'code', 'asc')
      }
      return _data
    },
    calibrationSubTypeOptions() {
      let _data = this.calibrationTypes
      _data = _data.filter( (item) => item.id != 18)
      return _data
    },
    infoTypes() {
      let _data = []
      if (this.lookups['Source']) {
        this.lookups['Source'].forEach((element) => {
          if (element.name !== 'Vehicle') {
            _data.push(element)
          }
        })
      }
      console.log('infoTypes', _data)
      return _data
    },
    adassystems() {
      let cnt = 1
      let _data = []
      if (this.lookups['SystemType']) {
        let types = JSON.parse(JSON.stringify(this.lookups['SystemType']))
        _data = globals.sortArray(types, 'value', 'asc')
        types.forEach((element) => {
          element.id = cnt
          cnt++
        })
      }
      return _data
    },
    adaslocations() {
      let cnt = 1
      let _data = []
      if (this.lookups['LocationType']) {
        let types = JSON.parse(JSON.stringify(this.lookups['LocationType']))
        _data = globals.sortArray(types, 'value', 'asc')
        types.forEach((element) => {
          element.id = cnt
          cnt++
        })
      }
      return _data
    },
    cccKeywordsLine() {
      let _data = []
      if (this.lookups['CCCKeywordsLine']) {
        _data = this.lookups['CCCKeywordsLine']
      }
      return _data
    },
    cccKeywordsLocation() {
      let _data = []
      if (this.lookups['CCCKeywordsLocation']) {
        _data = this.lookups['CCCKeywordsLocation']
      }
      return _data
    },
    cccKeywordsSublet() {
      let _data = []
      if (this.lookups['CCCKeywordsSublet']) {
        _data = this.lookups['CCCKeywordsSublet']
      }
      return _data
    },
    adasChecklistMatrixVehicle() {
      let _data = null
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.adasChecklistMatrixVehicle
      }
      return _data
    },
    yearStart: {
      get() {
        let _data = null
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.yearStart
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'yearStart',
          value: value
        })
      }
    },
    yearEnd: {
      get() {
        let _data = null
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.yearEnd
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'yearEnd',
          value: value
        })
      }
    },
    matrixSource: {
      get() {
        let _data = null
        if (this.adasmakematrix) {
          if (this.adasmakematrix.source) {
            _data = parseInt(this.adasmakematrix.source)
          } else {
            _data = 1
          }
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'source',
          value: parseInt(value)
        })
        this.changeView(value)
      }
    },
    make: {
      get() {
        let _data = null
        if (this.adasmakematrix) {
          if (this.adasmakematrix.vehicleMake) {
            _data = this.adasmakematrix.vehicleMake.toString()
          }
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'make',
          value: value
        })
      }
    },
    model: {
      get() {
        let _data = null
        if (this.adasmakematrix) {
          if (this.adasmakematrix.vehicleModel) {
            _data = this.adasmakematrix.vehicleModel.toString()
          }
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'model',
          value: value
        })
      }
    },
    models() {
      let _data = []
      if (this.adasmakematrix) {
        if (this.adasmakematrix.models) {
          this.adasmakematrix.models.forEach((element) => {
            if (!element.isDelete) {
              _data.push(element)
            }
          })
        }
      }
      return _data
    },
    isModelThere() {
      return this.newModelVariability !== null
    },
    vehicleInfo() {
      let _info = null
      if (this.adasmakematrix) {
        let make = ''
        let found = this.lookups['VehicleMake'].find((x) => parseInt(x.id) === parseInt(this.adasmakematrix.vehicleMake))
        if (found) {
          make = found.name
        }
        if (this.adasmakematrix.yearStart && this.adasmakematrix.yearEnd) {
          _info = `${this.adasmakematrix.yearStart} - ${this.adasmakematrix.yearEnd} ${make} ${
            this.adasmakematrix.vehicleModel ? this.adasmakematrix.vehicleModel : ''
          }`
        }
      }
      // console.log('got vehicle info', _info)
      return _info
    },
    systemType: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.systemType
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'systemType',
          value: parseInt(value)
        })
      }
    },
    locationType: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.locationType
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'locationType',
          value: parseInt(value)
        })
      }
    },
    system: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.system
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'system',
          value: value
        })
      }
    },
    location: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.location
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'location',
          value: value
        })
      }
    },
    url: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.url
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'url',
          value: value
        })
      }
    },
    isRR: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.isRR
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'isRR',
          value: value
        })
      }
    },
    isRI: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.isRI
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'isRI',
          value: value
        })
      }
    },
    calibrationType: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.calibrationType
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'calibrationType',
          value: value
        })
      }
    },
    isInactive: {
      get() {
        let _data = ''
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.isInactive
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'isInactive',
          value: value
        })
      }
    },
    cccLineKeywords() {
      let _data = []
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.cccLineKeywords
      }
      return _data
    },
    cccLocationKeywords() {
      let _data = []
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.cccLocationKeywords
      }
      return _data
    },
    cccSubletKeywords() {
      let _data = []
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.cccSubletKeywords
      }
      return _data
    },
    systems() {
      let _data = []
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.systems
      }
      return _data
    },
    locations() {
      let _data = []
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.locations
      }
      return _data
    },
    staticCalibrate() {
      let _data = []
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.static
      }
      return _data
    },
    dynamicCalibrate() {
      let _data = []
      if (this.adasmakematrix) {
        _data = this.adasmakematrix.dynamic
      }
      return _data
    },
    isTriggerThere() {
      let _is = false
      if (this.adasmakematrix) {
        if (this.adasmakematrix.triggerNotice) {
          if (this.adasmakematrix.triggerNotice !== '') {
            _is = true
          }
        }
      }
      return _is
    },
    isCheckedRemoveLinks() {
      let _is = false
      if (this.links) {
        this.links.forEach((element) => {
          if (element.isChecked) {
            _is = true
          }
        })
      }
      return _is
    },
    links() {
      let _data = []
      if (this.adasmakematrix) {
        if (this.adasmakematrix.links) {
          _data = JSON.parse(JSON.stringify(this.adasmakematrix.links))
          if (_data) {
            if (this.viewLookup) {
              _data = _data.filter((x) => parseInt(x.lookupType) === parseInt(this.viewLookup))
            }
            if (this.viewYear) {
              _data = _data.filter((x) => parseInt(x.year) === parseInt(this.viewYear))
            }
            if (this.viewModel) {
              _data = _data.filter((x) => x.model === this.viewModel)
            }
            if (_data) {
              _data.forEach((element) => {
                element.isChecked = false
                element.isSelected = false
                if (parseInt(this.adaslinkSelected) === parseInt(element.adaslinks)) {
                  element.isSelected = true
                }
                let found = this.checkedLinks.find((x) => parseInt(x) === parseInt(element.adaslinks))
                if (found) {
                  element.isChecked = true
                }
              })
            }
          }
          if (this.sortBy === 'model') {
            _data = _.sortBy(_data, ['model', 'year'])
          } else {
            _data = _.sortBy(_data, ['year', 'model'])
          }
        }
      }
      return _data
    },
    isCheckedRemoveUrlLinks() {
      let _is = false
      if (this.adasLinks) {
        this.adasLinks.forEach((element) => {
          if (element.isChecked) {
            _is = true
          }
        })
      }
      return _is
    },
    urlLinks() {
      let _data = []
      if (this.adasLinks) {
        _data = JSON.parse(JSON.stringify(this.adasLinks))
        if (_data) {
          _data.forEach((element) => {
            element.isChecked = false
            let found = this.checkedLinkUrls.find((x) => parseInt(x) === parseInt(element.id))
            if (found) {
              element.isChecked = true
            }
          })
        }
      }
      return _data
    },
    categoryOrChecked: {
      get() {
        var _isChecked = false
        if(this.adasmakematrix && this.adasmakematrix.calibrationType) {
            _isChecked = this.adasmakematrix.calibrationType == 18 /* TODO: Make Constant */
            if(_isChecked && this.loadedSubCategories == false) {
              this.constructSubCategoriesFromMatrix()
            }
            this.ensureTwoSubCategories()
        }
        return _isChecked
      },
      set(value) {
        var _newCalibrationTypeValue = null;
        if(value === true) {
          _newCalibrationTypeValue = this.calibrationTypes.find( (item) => item.id == 18 ).id; 
          this.addedSubCategories = []
          this.ensureTwoSubCategories()
        }
        this.calibrationType = _newCalibrationTypeValue
      }
    },
    isAddlOperationRequired: {
      get() {
        let _data = false
        if (this.adasmakematrix) {
          _data = this.adasmakematrix.isAddlOperationRequired
        }
        return _data
      },
      set(value) {
        this.updateAdasMakeMatrix({
          name: 'isAddlOperationRequired',
          value: value
        })
      }
    },
    allAddlOperations() {
      let _data = []
      if (this.lookups['AddlOperation']) {
        _data = this.lookups['AddlOperation']
      }
      return _data
    },
    selectedAddlOperations() {
      let _data = []
      if (this.adasmakematrix && this.adasmakematrix.addlOperations) {
        _data = this.adasmakematrix.addlOperations.filter(x => !x.isDeleted || x.isDeleted === false)
      }
      return _data
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, [
      'updateAdasMakeMatrix',
      'saveAdasMakeMatrix',
      'saveAdasMakeMatrixLookups',
      'getAdasLinks',
      'resetData',
      'setLink',
      'saveAdasLinks',
      'removeAdasLinks',
      'pullAlldataLinks',
      'getAdasMakeMatrix',
      'createAdasLinks',
      'updateAdasMatrixInfoLookup',
      'importMakeMatrixLinks',
      'updateAdasLinks',
      'moveAdasMakeMatrix',
      'getMakeExceptionLookups',
      'getModelVariability',
      'saveModelVariability'
    ]),
    createAddlOperation() {
      this.isCreateAddlOperation = !this.isCreateAddlOperation
      if (this.isCreateAddlOperation) {
        setTimeout(() => {
          this.$refs.refCreateAddlOperation.focus()
        }, 250)
      }
    },
    addingAddlOperation(event) {
      if (event.key === 'Enter') {
        this.addAddlOperation()
        event.stopImmediatePropagation()
      }
    },
    addAddlOperation() {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'addAddlOperation',
        value: {
          adasChecklistMatrixVehicle: this.adasmakematrix.adasChecklistMatrixVehicle,
          isActive: false,
          addlOperation: this.newAddlOperation.replace(/,/g, '~')
        }
      })
      this.newAddlOperation = null
    },
    removeAddlOperation(value) {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'removeAddlOperation',
        value: value
      })
    },
    onAddlOperationStatusChanged(event, item, idx) {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'updateAddlOperation',
        value: {
          index: idx,
          item: item,
          newValue: event.target.checked
        }
      })
    },
    showTab(value) {
      this.isShowActions = true
      this.closeModelVariability()
      if (this.isSave) {
        this.save(true)
      }
      this.currentTab = value
      if (this.currentTab === 'Exceptions') {
        console.log('Tab Exceptions', this.adasmakematrix)
        this.isShowActions = false
        let make = ''
        let found = this.lookups['VehicleMake'].find((x) => parseInt(x.id) === parseInt(this.adasmakematrix.vehicleMake))
        if (found) {
          console.log('Loading up the Make Exceptions', found)
          make = found.name
          this.getMakeExceptionLookups({
            make: make,
            adasChecklistMatrixName: this.modelValue.subtitle
          })
        }
      }
    },
    reset() {
      this.isSave = false
      this.isSavingNewModel = false
      this.adaslinkSelected = 0
      this.loading = false
      this.currentTab = 'Vehicle'
      this.makes = []
      this.checkedLinks = []
      this.checkedLinkUrls = []
      this.isCreateCccLineKeyword = false
      this.newCccLineKeyword = null
      this.isCreateCccLocationKeyword = false
      this.newCccLocationKeyword = null
      this.isCreateCccSubletKeyword = false
      this.newCccSubletKeyword = null
      this.viewLookup = 1
      this.viewYear = null
      this.viewModel = null
      this.newModel = null
      this.newModels = []
      this.modelExcept = null
      this.isRemoving = false
      this.isRemovingUrls = false
      this.isPulling = false
      this.pullProgress = null
      this.sortBy = 'year'
      this.resetData('adasLinks')
      this.clearModel()
      this.isImporting = false
      this.isShowActions = true
      this.closeModelVariability()
      this.addedSubCategories = []
      this.loadedSubCategories = false,
      this.isCreateAddlOperation = false
    },
    close() {
      this.reset()
      this.$emit('closing')
    },
    cleanName(name) {
      let temp = name
      try {
        if (name) {
          if (name.indexOf('~') > 0) {
            temp = name.replace(/~/g, ',')
          }
        }
      } catch (error) {
        console.log('Clean Name', {
          name: name,
          error: error
        })
      }
      return temp
    },
    showTrigger() {
      console.log('Showing Trigger', this.adasmakematrix)
      this.actionTrigger = this.adasmakematrix
    },
    closeModal() {
      this.actionTrigger = null
      this.actionView = null
      this.actionDelete = null
      this.actionEditLinks = null
      this.actionMove = null
    },
    changedView() {
      this.adaslinkSelected = 0
      this.checkAll = false
      this.checkAllLinks = false
      this.checkedLinks = []
      this.resetData('adasLinks')
    },
    changeView() {},
    async changedSort() {
      console.log('Changed Sort', this.sortBy)
    },
    selectedType() {
      this.$nextTick(() => {
        console.log('Selected Type', this.types)
      })
    },
    processType(type) {
      let _type = ''
      // 0 = System, 1 = Location, 2 = Static, 3 = Dynamic, 99 = ALL
      switch (type) {
        case 1:
          _type = 'System'
          break
        case 2:
          _type = 'Location'
          break
        case 3:
          _type = 'Static'
          break
        case 4:
          _type = 'Dynamic'
          break
        case 99:
          _type = 'ALL'
          break
      }
      return _type
    },
    moveToCategory() {
      if (this.moveToAdasCategory && !this.showingAddModelVariability) {
        this.confirmTitle = 'Move to New Category?'
        this.confirmAction = 'Move'
        this.confirmQuestion = 'Are you sure you wish to Move this to a another Category?'
        this.actionMove = {
          adasChecklistMatrix: this.moveToAdasCategory
        }
      } else {
        if (!this.showingAddModelVariability) {
          alert('Please choose a Category')
        }
      }
    },
    async performMove() {
      let data = {
        id: this.adasmakematrix.adasChecklistMatrixVehicle,
        to: this.moveToAdasCategory
      }
      this.actionMove = null
      console.log('Moving to Category', data)
      await this.moveAdasMakeMatrix(data)
      this.$emit('saved')
    },
    createCccLineKeyword() {
      this.isCreateCccLineKeyword = !this.isCreateCccLineKeyword
      if (this.isCreateCccLineKeyword) {
        setTimeout(() => {
          this.$refs.refCreateCccLineKeyword.focus()
        }, 250)
      }
    },
    addingCccLineKeyword(event) {
      if (event.key === 'Enter') {
        this.addCccLineKeyword()
        event.stopImmediatePropagation()
      }
    },
    addCccLineKeyword() {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'addCccLineKeyword',
        value: this.newCccLineKeyword.replace(/,/g, '~')
      })
      this.newCccLineKeyword = null
    },
    removeCccLineKeyword(value) {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'removeCccLineKeyword',
        value: value
      })
    },
    createCccLocationKeyword() {
      this.isCreateCccLocationKeyword = !this.isCreateCccLocationKeyword
      if (this.isCreateCccLocationKeyword) {
        setTimeout(() => {
          this.$refs.refCreateCccLocationKeyword.focus()
        }, 250)
      }
    },
    addingCccLocationKeyword(event) {
      if (event.key === 'Enter') {
        this.addCccLocationKeyword()
        event.stopImmediatePropagation()
      }
    },
    addCccLocationKeyword() {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'addCccLocationKeyword',
        value: this.newCccLocationKeyword.replace(/,/g, '~')
      })
      this.newCccLocationKeyword = null
    },
    removeCccLocationKeyword(value) {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'removeCccLocationKeyword',
        value: value
      })
    },
    createCccSubletKeyword() {
      this.isCreateCccSubletKeyword = !this.isCreateCccSubletKeyword
      if (this.isCreateCccSubletKeyword) {
        setTimeout(() => {
          this.$refs.refCreateCccSubletKeyword.focus()
        }, 250)
      }
    },
    addingCccSubletKeyword(event) {
      if (event.key === 'Enter') {
        this.addCccSubletKeyword()
        event.stopImmediatePropagation()
      }
    },
    addCccSubletKeyword() {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'addCccSubletKeyword',
        value: this.newCccSubletKeyword.replace(/,/g, '~')
      })
      this.newCccSubletKeyword = null
    },
    removeCccSubletKeyword(value) {
      this.isSave = true
      this.updateAdasMakeMatrix({
        name: 'removeCccSubletKeyword',
        value: value
      })
    },
    addingSystem(event) {
      if (event.key === 'Enter') {
        this.addSystem()
        event.stopImmediatePropagation()
      }
    },
    addSystem() {
      this.updateAdasMakeMatrix({
        name: 'systemLookup',
        value: this.newSystem
      })
      this.newSystem = null
    },
    removeSystem(value) {
      this.updateAdasMakeMatrix({
        name: 'removeSystem',
        value: value
      })
    },
    addingLocation(event) {
      if (event.key === 'Enter') {
        this.addLocation()
        event.stopImmediatePropagation()
      }
    },
    addLocation() {
      this.updateAdasMakeMatrix({
        name: 'locationLookup',
        value: this.newLocation
      })
      this.newLocation = null
    },
    removeLocation(value) {
      this.updateAdasMakeMatrix({
        name: 'removeLocation',
        value: value
      })
    },
    addingStatic(event) {
      if (event.key === 'Enter') {
        this.addStatic()
        event.stopImmediatePropagation()
      }
    },
    addStatic() {
      this.updateAdasMakeMatrix({
        name: 'staticLookup',
        value: this.newStatic
      })
      this.newStatic = null
    },
    removeStatic(value) {
      this.updateAdasMakeMatrix({
        name: 'removeStatic',
        value: value
      })
    },
    addingDynamic(event) {
      if (event.key === 'Enter') {
        this.addDynamic()
        event.stopImmediatePropagation()
      }
    },
    addDynamic() {
      this.updateAdasMakeMatrix({
        name: 'dynamicLookup',
        value: this.newDynamic
      })
      this.newDynamic = null
    },
    removeDynamic(value) {
      this.updateAdasMakeMatrix({
        name: 'removeDynamic',
        value: value
      })
    },
    trimUrl(url) {
      let _url = null
      if (url) {
        _url = url.substring(0, 50) + ' ...'
      }
      return _url
    },
    async pull() {
      await this.save(true)
      let make = null
      let found = this.lookups['VehicleMake'].find((x) => parseInt(x.id) === parseInt(this.adasmakematrix.vehicleMake))
      if (found) {
        make = found.name
      }
      if (make) {
        this.isPulling = true
        this.pullProgress = null
        await this.viewYears.forEach(async (element) => {
          let data = {
            year: element.value.toString(),
            make: make,
            model: this.model,
            vehicleMake: parseInt(this.adasmakematrix.vehicleMake),
            lookupType: null
          }
          this.pullProgress = `pulling ${element.value} ${make} ${this.model}...`
          await this.pullAlldataLinks(data)
        })
        await this.getAdasMakeMatrix(this.adasmakematrix.adasChecklistMatrixVehicle)
        this.isPulling = false
        this.pullProgress = null
        alert('Successfully, pulled ALLDATA links')
      }
    },
    addLink() {
      this.setLink({
        name: 'linkAdd',
        value: {
          id: this.links.length + 1,
          title: this.newLink.title,
          url: this.newLink.url,
          type: this.viewLookup,
          year: this.viewYear,
          model: this.viewModel
        }
      })
      this.newLink = {
        id: 0,
        title: null,
        url: null
      }
      this.isSave = true
    },
    async removeLink(link) {
      if (this.isSave) {
        await this.save(true)
      }
      this.setLink({
        name: 'linkRemove',
        value: link
      })
      this.isSave = true
    },
    showAddModelVariability() {
      this.isShowModelVariability = false
      this.showingModelVariability = false
      this.showingAddModelVariability = false
      this.newModelVariability = null
      this.isShowAddModelVariability = !this.isShowAddModelVariability
      if (this.isShowAddModelVariability) {
        this.showingAddModelVariability = true
      }
    },
    addModelVariability() {
      if (this.newModelVariability !== null) {
        // add to models via store, set a save flag
        this.updateAdasMakeMatrix({
          name: 'addModelVariability',
          value: this.newModelVariability
        })
        this.isShowAddModelVariability = false
        this.showingAddModelVariability = false
        this.showingModelVariability = false
        this.isShowModelVariability = false
        this.newModelVariability = null
        this.isSave = true
        setTimeout(() => {
          this.showingModelVariability = true
          this.isShowModelVariability = true
          if (this._computedWatchers) {
            if (this._computedWatchers.models) {
              this._computedWatchers.models.run()
            }
          }
        }, 250)
      }
    },
    showModelVariability() {
      this.isShowAddModelVariability = false
      this.showingModelVariability = false
      this.showingAddModelVariability = false
      this.newModelVariability = null
      this.isShowModelVariability = !this.isShowModelVariability
      if (this.isShowModelVariability) {
        this.showingModelVariability = true
      }
    },
    removeModelVariability(id) {
      this.updateAdasMakeMatrix({
        name: 'removeModelVariability',
        value: parseInt(id)
      })
      this.isSave = true
      setTimeout(() => {
        this.$forceUpdate()
        if (this._computedWatchers) {
          if (this._computedWatchers.models) {
            this._computedWatchers.models.run()
          }
        }
      }, 250)
    },
    closeModelVariability() {
      this.isShowModelVariability = false
      this.isShowAddModelVariability = false
      this.showingModelVariability = false
      this.showingAddModelVariability = false
      this.newModelVariability = null
    },
    clearModel() {
      this.viewModel = null
      this.isAddModel = false
      this.viewYear = null
    },
    checkForEnter() {
      this.addModel()
    },
    async addModel() {
      if (this.isAddModel) {
        this.isSavingNewModel = true
        let found = this.viewModels.find((x) => x.name.toLowerCase().trim() === this.newModel.toLowerCase().trim())
        if (!found) {
          let years = ''
          this.viewYears.forEach((element) => {
            if (years !== '') {
              years += ','
            }
            years += parseInt(element.value)
          })
          let data = {
            adasChecklistMatrix: this.adasmakematrix.adasChecklistMatrix,
            adasChecklistMatrixVehicle: this.adasmakematrix.adasChecklistMatrixVehicle,
            calibrationType: this.adasmakematrix.calibrationType,
            vehicleMake: this.adasmakematrix.vehicleMake,
            model: this.newModel,
            years: years,
            links: null
          }
          await this.createAdasLinks(data)
          this.adaslinkSelected = 0
          this.checkedLinks = []
          this.checkedLinkUrls = []
          this.resetData('adasLinks')
          this.isAddModel = false
          this.newModel = null
          await this.getAdasMakeMatrix(this.adasmakematrix.adasChecklistMatrixVehicle)
          this.isSavingNewModel = false
        } else {
          this.adaslinkSelected = 0
          this.checkedLinks = []
          this.checkedLinkUrls = []
          this.resetData('adasLinks')
          this.isAddModel = false
          this.newModel = null
        }
      } else {
        this.isAddModel = true
        setTimeout(() => {
          this.$refs.refNewModel.focus()
        }, 250)
      }
    },
    previewLink() {
      this.actionView = this.adasLink
    },
    async viewAdasLink(adaslinks) {
      this.loading = true
      if (this.isSave) {
        await this.save(true)
      }
      this.adaslinkSelected = adaslinks
      await this.getAdasLinks(adaslinks)
      this.loading = false
    },
    checkingAll() {
      setTimeout(() => {
        this.checkedLinks = []
        if (this.checkAll) {
          this.links.forEach((element) => {
            this.checkedLinks.push(parseInt(element.adaslinks))
          })
        }
        this.$forceUpdate()
      }, 100)
    },
    uncheckExceptModels() {
      this.checkedLinks = []
      if (this.checkAll) {
        this.links.forEach((element) => {
          if (element.model.toLowerCase().trim().indexOf(this.modelExcept.toLowerCase().trim()) < 0) {
            this.checkedLinks.push(parseInt(element.adaslinks))
          }
        })
      }
      this.$forceUpdate()
    },
    async checkAdasLink(adaslinks) {
      let found = this.checkedLinks.find((x) => parseInt(x) === parseInt(adaslinks))
      if (!found) {
        this.checkedLinks.push(parseInt(adaslinks))
      } else {
        this.checkedLinks = this.checkedLinks.filter((x) => parseInt(x) !== parseInt(adaslinks))
      }
    },
    async removeCheckedLinks() {
      if (this.checkedLinks.length > 0) {
        this.confirmTitle = 'Remove these ADAS Link(s)?'
        this.confirmAction = 'Remove'
        this.confirmQuestion = 'Are you sure you wish to Remove these ADAS Link(s)?'
        this.actionDelete = {
          adaslinks: this.checkedLinks,
          whichLinks: 'link'
        }
      }
    },
    async performDelete(data) {
      this.isRemoving = true
      this.actionDelete = null
      let adasLinks = {
        adasLinks: []
      }
      console.log('Perform Delete', data)
      if (data.whichLinks === 'link') {
        this.checkedLinks.forEach((element) => {
          adasLinks.adasLinks.push({
            adasLink: element
          })
        })
        console.log('Perform Delete - remove Adas Link')
        await this.removeAdasLinks(adasLinks)
      } else if (data.whichLinks === 'url') {
        this.checkedLinkUrls.forEach((element) => {
          this.setLink({
            name: 'linkRemove',
            value: element
          })
        })
        console.log('Perform Delete - remove Adas Link Url')
        await this.save(true)
        console.log('Perform Delete - force update')
        setTimeout(() => {
          this.cnt++
          this.$forceUpdate()
        }, 250)
      }
      console.log('Perform Delete - reset')
      this.isSave = false
      this.checkAll = false
      this.checkAllLinks = false
      this.checkedLinks = []
      this.checkedLinkUrls = []
      this.modelExcept = null
      this.isRemoving = false
    },
    editSelectedLinks() {
      console.log('Editing Links', {
        checked: this.checkedLinks,
        links: this.links
      })
      if (this.checkedLinks.length > 0) {
        let found = this.links.find((x) => parseInt(x.adaslinks) === parseInt(this.checkedLinks[0]))
        if (found) {
          this.actionEditLinks = {
            year: found.year,
            model: found.model,
            checked: this.checkedLinks
          }
        }
      }
    },
    async performLinksUpdate(links) {
      console.log('Perform Links Update', links)
      for (let idx = 0; idx < links.checked.length; idx++) {
        const element = links.checked[idx]
        let data = {
          adasLinks: element,
          year: links.year,
          model: links.model
        }
        await this.updateAdasLinks(data)
      }
      this.actionEditLinks = null
      this.adaslinkSelected = 0
      this.checkedLinks = []
      this.checkedLinkUrls = []
      this.resetData('adasLinks')
      this.isAddModel = false
      this.newModel = null
      await this.getAdasMakeMatrix(this.adasmakematrix.adasChecklistMatrixVehicle)
    },
    checkingAllLinks() {
      setTimeout(() => {
        this.checkedLinkUrls = []
        if (this.checkAllLinks) {
          this.adasLinks.forEach((element) => {
            this.checkedLinkUrls.push(parseInt(element.id))
          })
        }
        this.$forceUpdate()
      }, 100)
    },
    async checkAdasLinkUrl(id) {
      let found = this.checkedLinkUrls.find((x) => parseInt(x) === parseInt(id))
      if (!found) {
        this.checkedLinkUrls.push(parseInt(id))
      } else {
        this.checkedLinkUrls = this.checkedLinkUrls.filter((x) => parseInt(x) !== parseInt(id))
      }
    },
    async removeCheckedUrlLinks() {
      if (this.checkedLinkUrls.length > 0) {
        this.confirmTitle = 'Remove these ADAS Link(s)?'
        this.confirmAction = 'Remove'
        this.confirmQuestion = 'Are you sure you wish to Remove these ADAS Link(s)?'
        this.actionDelete = {
          adaslinks: this.checkedLinkUrls,
          whichLinks: 'url'
        }
      }
    },
    async importData() {
      this.isImporting = true
      let results = await this.importMakeMatrixLinks({
        make: this.vehicleMake,
        yearStart: this.yearStart,
        yearEnd: this.yearEnd
      })
      console.log('Import Results', results)
      if (results) {
        if (results.notice) {
          this.isImporting = false
        } else if (results.error) {
          alert(results.error)
        }
      }
    },
    completed() {
      this.isImporting = false
    },
    validate() {
      let proceed = true
      if (this.isAdd && this.makes.length === 0) {
        proceed = false
        this.message = 'Please select at least one Make.'
      }
      if (proceed && this.adasmakematrix) {
        if (proceed && this.yearStart === null) {
          proceed = false
          this.message = 'Please select Year Start.'
        }
        if (proceed && this.yearEnd === null) {
          proceed = false
          this.message = 'Please select Year End.'
        }
        if (proceed && this.yearStart > this.yearEnd) {
          proceed = false
          this.message = 'Year Start must be less than or same as Year End.'
        }
        if (proceed && this.yearEnd < this.yearStart) {
          proceed = false
          this.message = 'Year End must be greater than or same as Year Start.'
        }
        if (proceed && this.matrixSource === null) {
          proceed = false
          this.message = 'Please select a Matrix Source.'
        }
        if (proceed && this.matrixSource !== null) {
          if (this.matrixSource === 2 || this.matrixSource === 3) {
            if (this.system === null || this.system === '') {
              proceed = false
              this.message = 'Please provide a Description.'
            } else if (this.url === null || this.url === '') {
              proceed = false
              this.message = 'Please provide a URL.'
            }
          }
        }
        if (this.matrixSource !== 2 && this.matrixSource !== 3) {
          if (proceed && (this.systemType === null || this.systemType === '')) {
            proceed = false
            this.message = 'Please select a System Type.'
          }
          if (proceed && (this.locationType === null || this.locationType === '')) {
            proceed = false
            this.message = 'Please select a Location Type.'
          }
          if (this.calibrationType === null || this.calibrationType === '') {
            proceed = false
            this.message = 'Please select a Service.'
          }
        }
      }
      return proceed
    },
    async save(dontClose) {
      let proceed = true
      this.message = ''
      // validation here...
      proceed = this.validate()
      if (proceed) {
        // Save the Make Matrix
        if (this.isAdd && this.makes.length > 0) {
          // ADDING...
          let cnt = 0
          let matrix = JSON.parse(JSON.stringify(this.adasmakematrix))
          if(this.addedSubCategories){
            var subTypes = this.addedSubCategories.filter( (item) => item.value != null ).map( item => parseInt(item.value))
            matrix.calibrationSubTypes = JSON.stringify(subTypes)
          } else {
            matrix.calibrationSubTypes = ""
          }
          console.log('Adding Make Matrix', matrix)
          for (let idx = 0; idx < this.makes.length; idx++) {
            const make = this.makes[idx]
            matrix.adasChecklistMatrixVehicle = null
            matrix.vehicleMake = make
            matrix.cccLineKeywords = matrix.cccLineKeywords.toString()
            matrix.cccLocationKeywords = matrix.cccLocationKeywords.toString()
            matrix.cccSubletKeywords = matrix.cccSubletKeywords.toString()
            if (this.adasmakematrix.addlOperations) {
              matrix.addlOperations = JSON.stringify(this.adasmakematrix.addlOperations)
            }
            console.log('Saving Make Matrix', matrix)
            // Save the ADAS Matrix
            let id = await this.saveAdasMakeMatrix(matrix)
            if (id !== null && id !== undefined) {
              // Save System, Location, Static, and Dynamic Lookups
              matrix.adasChecklistMatrixVehicle = parseInt(id)
              await this.saveAdasMakeMatrixLookups(matrix)
            }
            cnt++
          }
          console.log('Saved Make Matrix', cnt)
          this.isSave = false
          this.currentTab = 'Vehicle'
          this.adaslinkSelected = 0
          this.checkedLinks = []
          this.checkedLinkUrls = []
          this.resetData('adasLinks')
          this.$emit('saved')
        } else if (!this.isAdd) {
          // UPDATING...
          let matrix = JSON.parse(JSON.stringify(this.adasmakematrix))
          if (matrix.adasChecklistMatrixVehicle === null) {
            if (this.adasLink) {
              if (this.adasLink.adasChecklistMatrixVehicle !== null) {
                matrix.adasChecklistMatrixVehicle = this.adasLink.adasChecklistMatrixVehicle
              }
            }
          }
          matrix.cccLineKeywords = matrix.cccLineKeywords.toString()
          matrix.cccLocationKeywords = matrix.cccLocationKeywords.toString()
          matrix.cccSubletKeywords = matrix.cccSubletKeywords.toString()
          if(this.addedSubCategories){
            var subTypes = this.addedSubCategories.map( item => parseInt(item.value))
            matrix.calibrationSubTypes = JSON.stringify(subTypes)
          } else {
            matrix.calibrationSubTypes = ""
          }
          if (this.adasmakematrix.addlOperations) {
            matrix.addlOperations = JSON.stringify(this.adasmakematrix.addlOperations)
          }
          console.log('Updating Make Matrix', {
            adasMatrix: matrix,
            adasLinks: this.adasLink
          })
          // Save the ADAS Matrix
          let id = await this.saveAdasMakeMatrix(matrix)
          if (id !== null && id !== undefined) {
            // Save System, Location, Static, and Dynamic Lookups
            let matrix = JSON.parse(JSON.stringify(this.adasmakematrix))
            matrix.adasChecklistMatrixVehicle = parseInt(id)
            await this.saveAdasMakeMatrixLookups(matrix)
          }
          // Save ADAS Links
          if (this.adasLink) {
            if (this.types.length > 0) {
              let model = this.adasLink.model
              let year = this.adasLink.year
              let links = this.adasLink.links
              for (let idx = 0; idx < this.types.length; idx++) {
                const lookup = parseInt(this.types[idx].value)
                if (this.adasmakematrix.links) {
                  let found = this.adasmakematrix.links.find((x) => x.model === model && x.year === year && parseInt(x.lookupType) === lookup)
                  if (found) {
                    let id = found.adaslinks
                    await this.getAdasLinks(id)
                    let data = JSON.parse(JSON.stringify(this.adasLink))
                    data.links = links
                    await this.saveAdasLinks(data)
                  }
                }
              }
            } else {
              await this.saveAdasLinks(this.adasLink)
            }
          }
          // Save Model Variability
          if (this.adasmakematrix.models) {
            console.log('Checking Model Variability', this.adasmakematrix)
            let isAny = this.adasmakematrix.models.find((x) => x.isAdd || x.isDelete)
            if (isAny) {
              let models = []
              this.adasmakematrix.models.forEach((element) => {
                if (element.isAdd && parseInt(element.id) < 0) {
                  models.push({
                    adasChecklistMatrixVehicleModel: null,
                    adasChecklistMatrixVehicle: this.adasmakematrix.adasChecklistMatrixVehicle,
                    vehicleModel: element.name,
                    isAdd: element.isAdd,
                    isDelete: false
                  })
                } else if (element.isDelete && parseInt(element.id) > 0) {
                  models.push({
                    adasChecklistMatrixVehicleModel: parseInt(element.id) > 0 ? parseInt(element.id) : null,
                    adasChecklistMatrixVehicle: this.adasmakematrix.adasChecklistMatrixVehicle,
                    vehicleModel: element.name,
                    isAdd: false,
                    isDelete: element.isDelete
                  })
                }
              })
              await this.saveModelVariability(models)
            }
          }
          this.isSave = false
          this.checkedLinks = []
          this.checkedLinkUrls = []
          if (!dontClose) {
            this.resetData('adasLinks')
            this.adaslinkSelected = 0
            this.currentTab = 'Vehicle'
            this.viewLookup = 1
            this.viewYear = null
            this.viewModel = null
            this.$emit('saved')
          } else {
            console.log('Get Model Variability', matrix)
            this.getModelVariability(matrix.adasChecklistMatrixVehicle)
          }
        }
      } else {
        this.message = 'Please fill in all fields.'
      }
    },
    async removeSubcategoryOptionAt(idx){
      //console.log("Removing Item At Index: ", idx)
      this.addedSubCategories.splice(idx, 1)
      this.ensureTwoSubCategories()
    },
    async constructSubCategoriesFromMatrix(){
      this.addedSubCategories = [] //Init
      //Grab the content out of the matrix
      if(this.adasmakematrix && this.adasmakematrix.calibrationSubTypes) {
        var parsedValues = JSON.parse(this.adasmakematrix.calibrationSubTypes)

        for(var i = 0; i < parsedValues.length; i++)
        {
          var newItem = {
            value: parsedValues[i],
            id: i+1
          }
          this.addedSubCategories.push(newItem)
        }
        
        //Then ensure we have at least two options
        this.ensureTwoSubCategories()
      }
      this.loadedSubCategories = true
    },
    async ensureTwoSubCategories(){
      if(!this.addedSubCategories) this.addedSubCategories = []
      for(var desiredMinCount = 0; this.addedSubCategories.length < 2; desiredMinCount++) {
        this.addSubCategoryOption()
      }
    },
    async addSubCategoryOption() {
      var nextId = (this.addedSubCategories.length == 0) ? 1 : (this.addedSubCategories[this.addedSubCategories.length-1].id + 1)
      var newItem = {
        value: null,
        id: nextId
      }
      this.addedSubCategories.push(newItem)
    },
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 640px;
  min-height: 640px;
}
.custom-right-align {
  text-align: right;
}
.custom-value-wrapper {
  position: relative;
  top: 35px;
}
.custom-subtitle {
  display: inline-flex;
  select {
    top: -4px;
    margin-left: 5px;
    width: 250px;
  }
  button {
    position: relative;
    top: -4px;
  }
}
.custom-list-wrapper {
  max-height: 230px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-list-links-wrapper {
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-list {
  list-style-type: none;
  padding-inline-start: 10px;
  margin: 0;
  padding: 0;
  li {
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-top: 2px;
    margin-bottom: 2px;
  }
}
.custom-remove {
  width: 28px;
  margin-right: 5px;
}
.custom-trigger {
  position: relative;
  top: 30px;
}
.custom-select {
  width: 40px;
}
.custom-focus:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
  border: transparent;
}
.custom-link-ids-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 420px;
  height: 420px;
  padding-left: 0;
  padding-top: 5px;
  padding-right: 10px;
  border: 1px solid #dee2e6;
  margin-left: 15px;
}
.custom-link-ids {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.custom-link-id {
  position: relative;
  padding: 5px;
  width: 100%;
  font-weight: 500;
  border: 1px solid #dee2e6;
  margin: 5px;
  cursor: pointer;
}
.custom-link-id:hover {
  background: rgba(255, 251, 0, 0.1);
}
.custom-link-id-selected {
  background: rgba(255, 251, 0, 0.5);
}
.custom-link-remove {
  margin-right: 5px;
  padding-right: 5px;
  padding-left: 5px;
  float: right;
  color: red;
  cursor: pointer;
  border: 1px solid transparent;
}
.custom-link-remove:hover {
  border: 1px solid #dee2e6;
  background: rgba(0, 0, 0, 0.1);
}
.custom-remove-models {
  display: inline-flex;
}
.custom-link {
  width: 100%;
  margin: 0;
  position: relative;
  padding: 1px;
}
.custom-link:hover {
  background: rgba(255, 251, 0, 0.1);
}
.custom-link-title {
  font-weight: 600;
}
.custom-link-url {
  font-style: italic;
}
.custom-green-background {
  background: rgba(30, 255, 0, 0.1);
}
.custom-year-model {
  font-size: 0.8em;
}
.custom-link-check {
  position: absolute;
  right: 5px;
  bottom: 10px;
}
.custom-link-actions {
  text-align: right;
  padding-top: 5px;
}
.custom-vehicle-info {
  position: absolute;
  top: 0;
  right: 25px;
  font-style: italic;
}
.custom-links-right {
  float: right;
}
.custom-info-blue {
  color: #0069d9;
  font-size: 1.1em;
}
.custom-all-checkbox {
  right: 30px;
  position: relative;
}
.custom-preview {
  position: relative;
}
.custom-all-urls-checkbox {
  position: absolute;
  right: 45px;
  bottom: 10px;
}
.custom-link-input {
  height: auto;
}
.custom-required {
  position: relative;
  top: -4px;
  left: 3px;
  color: red;
}
.custom-model-variability {
  position: relative;
  top: 24px;
}
.custom-variability {
  position: absolute;
  z-index: 10;
  top: 40px;
  right: 0;
  border: 1px solid #ced4da;
  padding: 5px;
  background-color: #fff;
  width: 330px;
  box-shadow: 7px 8px 5px -2px rgba(0, 0, 0, 0.22);
  -webkit-box-shadow: 7px 8px 5px -2px rgba(0, 0, 0, 0.22);
  -moz-box-shadow: 7px 8px 5px -2px rgba(0, 0, 0, 0.22);
}
.custom-variability-list {
  min-height: 300px;
}
.custom-btn {
  border-color: #ced4da;
}
.custom-btn-focus:focus {
  border-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
  border: 1px solid #ced4da;
}
.custom-btn-right-radius {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.custom-model-variability-list {
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  list-style-type: none;
  padding: 0;
  margin: 10px;
  height: 300px;
  li {
    position: relative;
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-top: 2px;
    margin-bottom: 2px;
    span {
      left: 0;
    }
    a {
      position: absolute;
      right: 0;
    }
  }
}
.custom-model-count {
  position: absolute;
  top: -2px;
  right: 2px;
  font-size: 0.7em;
  color: #000;
}
.custom-model-exclusions {
  position: absolute;
  top: -20px;
  right: 10px;
  font-size: 0.8em;
}
.custom-model-exclusions-info {
  position: absolute;
  top: -10px;
}


.category-or-wrapper {
  margin-top:1em;
}
.category-or-wrapper label {
  display:inline;
}

.subcategoryRemove { 
  margin-left:-1em;
}
.subcategoryRemove button{ 
  background: white;
  padding:6px 9px;
}

</style>

